require('./modifyCommerceAndATMLimitsStep2.scss');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @core
const { formatText, getLanguage } = require('core/i18n').i18n;
// @components

const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY, CONFIRMATION_SCRIPT_AGREEMENT  } = require('components/contactCenter/confirmScript/confirmationScript');

// @constants
const {
    FIRST_STEP
} = require('constants/index');

// @helpers
const {
    formatAmountObject,
    getPlainAmountObject
} = require('utilities/currencyHelper');

class ModifyCommerceAndATMLimitsStep2 extends React.Component {

    buildStepData() {

        const { immModifyCommerceAndATMLimits, immCard } = this.props;

        const cardNumber = immCard.get('number');
        const cardHolder = immCard.get('titularName');

        const currentAmountLimit = immModifyCommerceAndATMLimits.getIn(['limitsData', 'data', 'importeLimiteActual', 'importe' ]);
        const newAmountLimit = immModifyCommerceAndATMLimits.getIn(['steps', FIRST_STEP, 'newSelectedLimit' ]);

        const currency = immModifyCommerceAndATMLimits.getIn(['limitsData', 'data', 'importeLimiteActual', 'divisa']);

        const currentLimitAmountObject = {
            amount: currentAmountLimit,
            currency,
            decimalsLength: 0
        };

        const newLimitAmountObject = {
            amount: newAmountLimit,
            currency,
            decimalsLength: 0
        }

        const language = getLanguage();
        const plainCurrentAmountObject = getPlainAmountObject(currentLimitAmountObject);
        const plainNewAmountObject = getPlainAmountObject(newLimitAmountObject);

        return (
            <div className="modify-commerce-and-atm-limits-step-2__data">
                <OKInformativeList columns={2}>
                    <OKInformativeListItem
                        title="modifyCommerceAndATMLimits-cardNumberLabel"
                        bodyText={cardNumber}
                    />
                    <OKInformativeListItem
                        title="modifyCommerceAndATMLimits-cardHolderLabel"
                        bodyText={cardHolder}
                    />
                    <OKInformativeListItem
                        title="modifyCommerceAndATMLimits-cardLimitLabel"
                    >
                        <OneLineSymbolAmount
                            amountObject={plainCurrentAmountObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainCurrentAmountObject, true)}
                            className="ok-informative-list-item__body-text"
                        />
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title="modifyCommerceAndATMLimits-cardNewLimitLabel"
                    >
                        <OneLineSymbolAmount
                            amountObject={plainNewAmountObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainNewAmountObject, true)}
                            className="ok-informative-list-item__body-text"
                        />
                    </OKInformativeListItem>
                </OKInformativeList>
            </div>
        );
    }

    render() {
        const { limitType } = this.props;
        const content = this.buildStepData();

        return (
            <article className="modify-commerce-and-atm-limits-step-2" id="printable-wizard">
                <h1 className="wizard-step--vertical__title">
                    {formatText('modifyCommerceAndATMLimits-step2Title')}
                </h1>
                <h2 className="modify-commerce-and-atm-limits-step-2__subtitle">
                    {formatText('modifyCommerceAndATMLimits-step2Subtitle')}
                </h2>
                <div className="modify-commerce-and-atm-limits-step-2__confirmation-script">
                    <ConfirmationScript operative={formatText(`operatives-${limitType}ModifyLimit`)} confirmationType={CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY} />
                </div>
                {content}
                <div className="modify-commerce-and-atm-limits-step-2__confirmation-script">
                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                </div>
            </article>
        );
    }
}

ModifyCommerceAndATMLimitsStep2.propTypes = {
    immModifyCommerceAndATMLimits: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired,
    limitType: PropTypes.string.isRequired
};

module.exports = ModifyCommerceAndATMLimitsStep2;
